module.exports = "/packs/images/svg/ireland/accessibility/adapted_wheelchair~f31d61d914a4ff34adb25b089bc136bd.svg";